<template>
    <DsTextInput
        v-model="model"
        v-bind="{ ...$props, ...$attrs }"
        class="ds-textarea"
        type=""
    >
        <template
            v-for="(_, slot) in $slots"
            #[slot]="scope"
        >
            <slot
                :name="slot"
                v-bind="scope"
            />
        </template>

        <template #input="{ inputClass, elementId }">
            <textarea
                v-model="model"
                :id="elementId"
                ref="textareaElement"
                :autofocus
                :class="[inputClass, { 'resize-none': !resizable || disabled, 'has-error': !!error }]"
                :disabled
                :placeholder="!disabled ? placeholder : ''"
                :rows
            />
        </template>
    </DsTextInput>
</template>

<script setup lang="ts">
import DsTextInput from '@ds/form/input/text/DsTextInput.vue';
import type { DsTextareaProps } from '@ds/form/input/text/text-input.types';
import { useTemplateRef } from 'vue';

const model = defineModel<string>();

withDefaults(defineProps<DsTextareaProps>(), {
    rows: 5,
    resizable: true,
});

const textareaElement = useTemplateRef('textareaElement');

defineExpose({
    textareaElement,
});
</script>

<style scoped lang="scss">
.ds-textarea {
    :deep(.ds-input-inner-wrapper) {
        @apply h-auto;
    }

    :deep(.input-field) {
        @apply h-auto;
    }
}
</style>
